import styled from 'styled-components';
import RentalCompanyIconBase from '#/shared/components/RentalCompanyIcon';

export const RentalBadge = styled.div`
  width: 30px;
  height: 30px;
  font-size: 1.2em;
  background-color: ${props => props.color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.badgeBorderColor};
  user-select: none;
  cursor: default;
`;

export const RentalCompanyIcon = styled(RentalCompanyIconBase).attrs(props => ({
  width: 30,
  height: 30,
  title: props.title,
  fill: '#fff',
}))``;
